import React, { useReducer } from 'react'
import ModalBase from 'LuxKit/Modal/ModalBase'
import { ContentfulModalDispatchAction, ContentfulModalDispatchContext, ContentfulModalState, ContentfulModalStateContext, ContentfulModalStateReducer } from './ContentfulModalContext'
import ModalComponents from './ModalComponents'

interface Props {
  contentModals?: Array<App.ContentfulWebPageModalComponent>
  slug: string | null
}

function ContentfulModal(props: Props) {
  const [state, dispatch] = useReducer<ContentfulModalState, [ContentfulModalDispatchAction]>(ContentfulModalStateReducer, { currentStep: props.slug })

  if (!props.contentModals || props.contentModals.length === 0) {
    return null
  }

  return <ModalBase size="L" onAfterClose={() => null}>
    <ContentfulModalStateContext.Provider value={state}>
      <ContentfulModalDispatchContext.Provider value={dispatch}>
        {props.contentModals.map(contentModal => (state?.currentStep === contentModal.slug) && <ModalComponents key={contentModal.slug} {...contentModal} />)}
      </ContentfulModalDispatchContext.Provider>
    </ContentfulModalStateContext.Provider>
  </ModalBase>
}

export default ContentfulModal
